<template>
  <div class="container py-5">
    <div class="row">
      <div class="col-md-8 mx-auto">
        <div class="card">
          <div class="card-header bg-primary text-white">
            <h4 class="mb-0">Tests psychométriques</h4>
          </div>
          
          <div class="card-body">
            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Chargement...</span>
              </div>
            </div>

            <div v-else>
              <!-- En-tête avec les informations de l'offre -->
              <div class="mb-4">
                <h5>{{ application?.jobOffer?.title }}</h5>
                <p class="text-muted mb-0">
                  Date limite pour compléter les tests : 
                  {{ formatDate(application?.deadline) }}
                </p>
              </div>

              <!-- Liste des tests -->
              <div class="list-group">
                <div v-for="test in assignedTests" :key="test.id" 
                     class="list-group-item list-group-item-action">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="mb-1">{{ test.test.name }}</h6>
                      <p class="mb-1 text-muted">
                        <small>Durée estimée : {{ test.test.duration_minutes }} minutes</small>
                      </p>
                    </div>
                    <div>
                      <span v-if="test.status === 'completed'" 
                            class="badge bg-success">
                        Complété
                      </span>
                      <button v-else-if="test.status === 'in_progress'"
                              class="btn btn-warning btn-sm"
                              @click="continueTest(test)">
                        Continuer
                      </button>
                      <button v-else
                              class="btn btn-primary btn-sm"
                              @click="startTest(test)">
                        Commencer
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Message si tous les tests sont complétés -->
              <div v-if="allTestsCompleted" class="alert alert-success mt-4">
                <h5 class="alert-heading">
                  <i class="fas fa-trophy me-2"></i>Félicitations !
                </h5>
                <p>
                  Vous avez complété tous les tests requis. Découvrez dès maintenant la synthèse
                  coaching de vos résultats.
                </p>
                <router-link
                  :to="{ name: 'MyTestResults', params: { applicationId: applicationId } }"
                  class="btn btn-success mt-2"
                >
                  <i class="fas fa-award me-2"></i>Voir mes résultats
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationTests',

  data() {
    return {
      application: null,
      assignedTests: [],
      loading: true
    }
  },

  computed: {
    allTestsCompleted() {
      return this.assignedTests.length > 0 &&
        this.assignedTests.every(test => test.status === 'completed')
    },
    applicationId() {
      return this.$route.params.id
    }
  },

  async created() {
    await this.loadApplicationTests()
  },

  methods: {
    async loadApplicationTests() {
      try {
        const applicationId = this.$route.params.id
        const response = await this.$http.get(`/applications/${applicationId}/tests`)
        
        this.application = response.data.application
        this.assignedTests = response.data.assigned_tests
      } catch (error) {
        console.error('Erreur lors du chargement des tests:', error)
        this.$toast.error('Erreur lors du chargement des tests')
      } finally {
        this.loading = false
      }
    },

    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },

    startTest(test) {
      this.$router.push({
        name: 'test-taking',
        params: { 
          id: test.id
        }
      })
    },

    continueTest(test) {
      this.$router.push({
        name: 'test-taking',
        params: { 
          id: test.id
        }
      })
    }
  }
}
</script>

<style scoped>
.list-group-item {
  transition: background-color 0.2s;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

.badge {
  font-size: 0.9rem;
  padding: 0.5em 0.8em;
}
</style> 